import { Modal } from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createLessons,
  resetcreateLessonsStatus,
} from "../../../../../../../state/actions/createLessonsAction";
import { useAuth } from "../../../../../../../features/auth/AuthContext";
import UploadFiles from "./UploadFiles";
// import LoaderComponent from "../../../../../../../components/LoaderComponent/LoaderComponent";
import Loader from "./Loader";

const MIN_CREATE_LESSON_COUNT = 1;
const MAX_CREATE_LESSON_COUNT = 10;
const DEFAULT_CREATE_LESSON_COUNT = 1;

const AddLessonModal = ({
  open = false,
  onClose = () => { },
  course = {},
  teacher_id = "",
  incrementCreateLessonCount,
  decrementCreateLessonCount,
  createLessonCount,
  setCreateLessonCount,
  createLessonStep,
  setCreateLessonStep,
  confirmCreateLessonNavigation,
  awaitingCreateLessonsNav,
  lessonsRefreshKey,
  setLessonsRefreshKey,
  enableClick,
  setEnableClick,
  setAwaitingCreateLessonsNav,
  links,
  setLinks,
  makeLinkRow,
  lowerSchool = false
}) => {
  const dispatch = useDispatch();
  const { token } = useAuth();
  const createLessonsState = useSelector((state) => state?.createLessons);
  const [selectedFiles, setSelectedFiles] = useState([]); // Files selected wither from the google drive or uploaded from the local computer
  const [selectedRepoFiles, setSelectedRepoFiles] = useState([]); // files selected from the my files
  const [loadingText, setLoadingText] = useState(
    "Lesson generation in progress...",
  ); // files selected from the my files
  const [showTabs, setShowTabs] = useState(true);
  const createLessonModalRef = useRef(null);

  const closeCreateLessonCountPopup = () => {
    onClose();
    setSelectedFiles([]);
    setSelectedRepoFiles([]);
    setLinks([makeLinkRow()])
  };

  const handleNext = async () => {
    if (!lowerSchool) {
      setCreateLessonStep(2);
      if (!enableClick) {
        setEnableClick(true);
      }
      return;
    }
    // Lower school skips the upload step, so create the lesson(s) here and
    // close the modal only after the request actually succeeds.
    try {
      await confirmCreateLessonNavigation(false);
      onClose();
    } catch (error) {
      // Keep the modal open so the teacher can retry.
      toast.error("Lesson creation failed. Please try again later.", {
        position: "top-center",
      });
    }
  }

  return (
    <Modal open={open} onClose={closeCreateLessonCountPopup}>
      <div className="view-course-details-share-form">
        <div
          ref={createLessonModalRef}
          className="w-full max-w-[950px] relative rounded-[16px] bg-white p-[32px_36px] shadow-[0_8px_40px_rgba(0,0,0,0.18)] max-[475px]:p-[17px_10px]"
        >
          {awaitingCreateLessonsNav && <Loader text={loadingText} />}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "24px",
            }}
          >
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 600 }}>
              Create Lessons
            </h2>
            <button
              type="button"
              onClick={closeCreateLessonCountPopup}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                color: "#555",
                lineHeight: 1,
              }}
              aria-label="Close"
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
          {!lowerSchool ? 
          <div
            style={{
              display: `${showTabs ? "flex" : "none"}`,
              alignItems: "center",
              paddingBottom: "16px",
              width: "55%",
              minWidth: 0,
            }}
            className="!w-full md:!w-[55%]"
          >
            <button
              type="button"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                border: "none",
                background: "transparent",
                padding: 0,
              }}
              onClick={() => setCreateLessonStep(1)}
            >
              <span
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  fontWeight: 700,
                  background: createLessonStep >= 1 ? "#0068ff" : "#e5e7eb",
                  color: createLessonStep >= 1 ? "#fff" : "#888",
                }}
              >
                1
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#0068ff",
                }}
              >
                Select No. of Lessons
              </span>
            </button>

            <div
              style={{
                flex: 1,
                height: "1px",
                background: "#d1d5db",
                margin: "0 16px",
              }}
            />

            <button
              onClick={() => {
                if (enableClick) {
                  setCreateLessonStep(2);
                }
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                border: "none",
                background: "transparent",
                padding: 0,
              }}
            >
              <span
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  fontWeight: 700,
                  background: createLessonStep === 2 ? "#0068ff" : "#e5e7eb",
                  color: createLessonStep === 2 ? "#fff" : "#888",
                }}
              >
                2
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: createLessonStep === 2 ? "#0068ff" : "#888",
                }}
              >
                Upload Lesson Files
              </span>
            </button>
          </div> : <></>}

          {createLessonStep === 1 && (
            <>
              <p
                style={{
                  fontSize: "15px",
                  color: "#333",
                  marginBottom: "20px",
                  borderTop: "1px solid #e5e7eb",
                  paddingTop: "28px",
                  fontWeight: 500,
                }}
              >
                Select the number of lesson titles you&apos;d like to generate.
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0,
                    border: "1px solid #d1d5db",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <button
                    type="button"
                    onClick={decrementCreateLessonCount}
                    disabled={createLessonCount <= MIN_CREATE_LESSON_COUNT}
                    style={{
                      width: "40px",
                      height: "42px",
                      background: "#F7F7F7",
                      border: "none",
                      cursor:
                        createLessonCount <= MIN_CREATE_LESSON_COUNT
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "18px",
                      color: "#333",
                      borderRight: "1px solid #d1d5db",
                      opacity:
                        createLessonCount <= MIN_CREATE_LESSON_COUNT ? 0.45 : 1,
                    }}
                  >
                    −
                  </button>
                  <div
                    style={{
                      width: "120px",
                      textAlign: "center",
                      fontSize: "15px",
                      fontWeight: 500,
                      padding: "0 12px",
                    }}
                  >
                    {createLessonCount}{" "}
                    {createLessonCount === 1 ? "Lesson" : "Lessons"}
                  </div>
                  <button
                    type="button"
                    onClick={incrementCreateLessonCount}
                    disabled={createLessonCount >= MAX_CREATE_LESSON_COUNT}
                    style={{
                      width: "40px",
                      height: "42px",
                      background: "#F7F7F7",
                      border: "none",
                      cursor:
                        createLessonCount >= MAX_CREATE_LESSON_COUNT
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "18px",
                      color: "#333",
                      borderLeft: "1px solid #d1d5db",
                      opacity:
                        createLessonCount >= MAX_CREATE_LESSON_COUNT ? 0.45 : 1,
                    }}
                  >
                    +
                  </button>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <button
                    type="button"
                    onClick={handleNext}
                    disabled={awaitingCreateLessonsNav}
                    style={{
                      background: "#0068ff",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 32px",
                      fontSize: "15px",
                      fontWeight: 600,
                      cursor: awaitingCreateLessonsNav
                        ? "not-allowed"
                        : "pointer",
                      opacity: awaitingCreateLessonsNav ? 0.6 : 1,
                    }}
                  >
                    {lowerSchool ? "Save" : "Next"}
                  </button>
                </div>
              </div>

              <p style={{ marginTop: "14px", fontSize: "13px", color: "#666" }}>
                Note: You can create up to {MAX_CREATE_LESSON_COUNT} lessons
              </p>
            </>
          )}

          {createLessonStep === 2 && (
            <>
              <UploadFiles
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                selectedRepoFiles={selectedRepoFiles}
                setSelectedRepoFiles={setSelectedRepoFiles}
                handleSave={confirmCreateLessonNavigation}
                handleFiles={() => { }}
                course={course}
                teacher_id={teacher_id}
                createLessonCount={createLessonCount}
                closeModal={onClose}
                setLoadingText={setLoadingText}
                setLoad={setAwaitingCreateLessonsNav}
                links={links}
                setLinks={setLinks}
                makeLinkRow={makeLinkRow}
              />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddLessonModal;
